import { Route, Routes } from "react-router-dom";
import { LoggedOutPage } from "./page";

export const OfflineRoute = () => (
  <Routes>
    <Route
      path="token-expired"
      element={<LoggedOutPage variant="tokenExpired" />}
    />
    <Route path="logged-out" element={<LoggedOutPage variant="loggedOut" />} />
  </Routes>
);
